import script from "./MembersRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersRequest.vue?vue&type=script&setup=true&lang=js"

import "./MembersRequest.vue?vue&type=style&index=0&id=3a5c1e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5c1e48"]])

export default __exports__